import { removeVeil } from "./utils";

export default function () {
    $("html").on("click", ".no-scroll", () => {
        removeVeil();
    });

    /**
     * This function removes preloader which was used on page loading
     */
    $(window).on("load", function () {
        $(".preloader").remove();
    });

    /**
     * In case load event wasn't triggered and was blocked by external scripts (FireFox issue)
     * Force to remove preloader
     */
    setTimeout(function () {
        const $preloader = $(".preloader");
        $preloader.length ? $preloader.remove() : "";
    }, 4000);
}
